/* tslint:disable */

declare var Object: any;
export interface ViewShiftscheduleReportInterface {
  "empId"?: string;
  "fullName"?: string;
  "posNameEn"?: string;
  "remark"?: string;
  "shiftdailyCode": string;
  "attendId": string;
  "shiftstarttime"?: Date;
}

export class ViewShiftscheduleReport implements ViewShiftscheduleReportInterface {
  "empId": string;
  "fullName": string;
  "posNameEn": string;
  "remark": string;
  "shiftdailyCode": string;
  "attendId": string;
  "shiftstarttime": Date;
  constructor(data?: ViewShiftscheduleReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewShiftscheduleReport`.
   */
  public static getModelName() {
    return "ViewShiftscheduleReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewShiftscheduleReport for dynamic purposes.
  **/
  public static factory(data: ViewShiftscheduleReportInterface): ViewShiftscheduleReport{
    return new ViewShiftscheduleReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewShiftscheduleReport',
      plural: 'ViewShiftscheduleReports',
      path: 'ViewShiftscheduleReports',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "shiftdailyCode": {
          name: 'shiftdailyCode',
          type: 'string'
        },
        "attendId": {
          name: 'attendId',
          type: 'string'
        },
        "shiftstarttime": {
          name: 'shiftstarttime',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewShiftscheduleReport.ts